module.exports = {"TXTWCL_Watch_Trailer":{"id":"TXTWCL_Watch_Trailer","defaultMessage":"Se trailer","flags":["TRACK"],"track":"Watch Trailer"}}